import { SvgIcon, SvgIconProps } from '@ha/dsl';
import React from 'react';

const buildIcon = (
  name: string,
  Svg: React.ComponentType,
): React.FC<SvgIconProps> => {
  const Icon: React.FC<SvgIconProps> = props => (
    <SvgIcon {...props}>
      <Svg />
    </SvgIcon>
  );
  Icon.displayName = name;
  return Icon;
};

export default buildIcon;
